import { effectScope, EffectScope, onScopeDispose } from 'vue'

import { Nullable } from '@shared/models/types/primary'

// eslint-disable-next-line
export const createSharedComposable = <T>(composable: (...args: any[]) => T) => {
  let subscribers = 0
  // eslint-disable-next-line
  let state: any = null
  let scope: Nullable<EffectScope> = null

  const dispose = () => {
    if (scope && --subscribers <= 0) {
      scope.stop()
      state = scope = null
    }
  }

  // eslint-disable-next-line
  return (...args: any): T => {
    subscribers++
    if (!state) {
      scope = effectScope(true)
      state = scope.run(() => composable(...args))
    }
    onScopeDispose(dispose)
    return state
  }
}
